var map = {
	"./": 4606,
	"./app-store.png": 2515,
	"./betriebe.jpg": 1000,
	"./betriebe.webp": 2421,
	"./blick.png": 9048,
	"./bonus-client.png": 1270,
	"./broadcast-client.png": 587,
	"./broadcast_reminder/calendar.jpg": 5506,
	"./broadcast_reminder/chart_laptop.png": 8498,
	"./chat-bg.svg": 6948,
	"./content_guide/bear.png": 6388,
	"./content_guide/berliner.png": 9571,
	"./content_guide/bunny.png": 1386,
	"./content_guide/burger.png": 8950,
	"./content_guide/digitec.png": 2962,
	"./content_guide/egg.gif": 9741,
	"./content_guide/fountain.png": 6410,
	"./content_guide/interview.png": 5027,
	"./content_guide/marroni.jpg": 2255,
	"./content_guide/story.png": 1457,
	"./content_guide/wall.png": 5591,
	"./coupon_book.png": 9535,
	"./couponing/bonus-logo.png": 8137,
	"./couponing/logo-mastercard.png": 1398,
	"./couponing/logo-niedermann.png": 4375,
	"./couponing/logo-paypal.png": 2783,
	"./couponing/logo-twint.png": 689,
	"./couponing/logo-valida.png": 5988,
	"./couponing/logo-visa.png": 7890,
	"./couponing/stgallen-wallpaper.jpg": 8411,
	"./customer-fallback-avatar.png": 6054,
	"./direct-message-client.png": 5934,
	"./fm1.png": 4898,
	"./index": 4606,
	"./index.js": 4606,
	"./laptop-bonus-rechts.png": 2191,
	"./laptop-bonus-rechts.webp": 359,
	"./laptop-bonus.png": 3489,
	"./laptop-bonus.webp": 4807,
	"./laptop-chat.png": 4301,
	"./laptop-chat.webp": 5170,
	"./laptop-loyalty.png": 7533,
	"./laptop-loyalty.webp": 1348,
	"./laptop-statistics.png": 2770,
	"./laptop-statistics.webp": 9343,
	"./login-image.jpg": 4317,
	"./logo-city-messenger.png": 7741,
	"./logo-fhs.png": 2430,
	"./logo-innosuisse.png": 1028,
	"./logo-pro-city.png": 8594,
	"./logo-st-gallen.png": 2755,
	"./logo-swiss-made-software.png": 2694,
	"./loyalty-client.png": 1264,
	"./placeholder_avatar.png": 3750,
	"./play-store.png": 5172,
	"./quote-chat-icons/gartner.png": 7948,
	"./quote-chat-icons/hootsuite.png": 2141,
	"./quote-chat-icons/mehner.png": 1573,
	"./quote-chat-icons/washington-post.png": 4052,
	"./quote-chat-icons/zuckerberg-alt.png": 2975,
	"./quote-chat-icons/zuckerberg.png": 7944,
	"./renuo.svg": 5874,
	"./settings-client.png": 7094,
	"./shop-overview-client.png": 2412,
	"./skyline-stgallen-gray.svg": 3834,
	"./skyline-stgallen.svg": 7239,
	"./smartphone-gray.png": 5401,
	"./smartphone-tilted.png": 5649,
	"./smartphone-tilted.webp": 6571,
	"./sms-template.png": 1313,
	"./srf.png": 3866,
	"./tagblatt.png": 3162,
	"./testimonials/dominic_kraehenbuehl.jpg": 5434,
	"./testimonials/guido_schildknecht.jpg": 5274,
	"./testimonials/katy_rohner.jpg": 7651,
	"./testimonials/samuel_schneider.jpg": 7623,
	"./testimonials/tanja_naegele.jpg": 4506,
	"./toponline.png": 6902,
	"./tvo.png": 939
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1206;